import React from 'react'
import Carousel from "react-multi-carousel";
import  "react-multi-carousel/lib/styles.css";




function testimonialsData() {

    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          partialVisibilityGutter: 40,
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
          partialVisibilityGutter: 40,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 428, min: 320 },
          items: 1,
          partialVisibilityGutter: 10,
          
        }
      };
  return (
    <div>
    <Carousel responsive={responsive}
    
    itemClass="carousel-item-padding-40-px"
    transitionDuration={500}
    infinite={true}
    autoPlay={false}
    autoPlaySpeed={1500}
    swipeable={true}
    >
    <div className='testimonilaBox'>
    <p className='parentstext'>
     It was an awesome lesson experience for Vedaant but all this would have been not possible without such a wonderful team of faculty members to help him in the process of building a fine an intelligent person he is now. 
Staying away from him was very hard on me but I knew he had more capabilities and it can be only achieved with more discipline and hardwork. 
Thanks to all of you for being so supportive and encouraging to Vedaant    </p>
    <h5  className='parentsname' >Neelu Heer (canada)</h5>
    <h5  className='parentsname' >Parent of Vedaant parihar </h5>
    <h5  className='parentsname' >((IGCSE - II))</h5>
    </div>
    <div className='testimonilaBox'>
    <p className='parentstext'>
     I joined the Cambridge curriculum in the year 2023. I found it extraordinary and good for my academic growth. The teachers here are very nice and they teach like professionals and experts. This curriculum does not let just students learn the answers but also make them sharp and out of the box thinkers. Many unique activities are conducted for the sutdents which makes the learning interesting.
    </p>
    <h5  className='parentsname' >Shrestha Sharma</h5>
    <h5  className='parentsname' >Student</h5>
    <h5  className='parentsname' >(CIE)</h5>
    </div>
    <div className='testimonilaBox'>    
    <p className='parentstext'>
      My journey of Cambridge Lower Secondary program beings in grade 6 where I met my new teachers and new friends. In the beginning the topics taught were new and difficult, but soon I beacame familiar with the kind of books and studies. It also became easier for me when the teachers taught the topics through different activities, like Hindi subject's 'leaf activity'. The assessment pattern is application based so I found it little tough in the beginning but now I am comfortable with it. In 7th grade my journey took a turn as there were few new teachers and a new subject was intorduced which was 'well being'. Things are going smoother now.
    </p>
    <h5  className='parentsname' >Yajat Gupta </h5>
    <h5  className='parentsname' >Student</h5>
    <h5  className='parentsname' >(CIE)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>
      I joined Sanskar School Cambridge program in the middle of grade 6. My journey and learning had been educational and eventful. I really like the way the curriculum is taken to classes, its practical approach in conduction of exams. The program mainly focuses on subjects like English, Maths, Science, ICT and Well Being. Overall the Cambridge board is a very practical approach for me and am looking forward to many more years of learning to come.
    </p>
    <h5  className='parentsname' >Aaradhya Madhav</h5>
    <h5  className='parentsname' >Student</h5>
    <h5  className='parentsname' > (CIE)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The IB diploma has given me a lot of knowledge not only about the subjects but also about other areas of life. The curriculum although rigorous teaches you to think from a different perspective. The facilitators at Sanskar School have helped me a lot in these two years and have played a crucial in achieving such great marks. All thr teachers are always ready in whatever way possible. Such an environment at school make it a second home for every student attending Sanskar School.</p>
    <h5  className='parentsname'>Krish Raj Choudhary</h5>
    <h5  className='parentsname'>Student</h5>
    <h5  className='parentsname'>(IBDP)</h5>
    </div>
    {/* <div className='testimonilaBox'>
    <h5  className='parentsname' >Kushagra Swaroop (Alumni)</h5>
    
    <p className='parentstext'>I have been a student of Sanskar School, Jaipur for the last 6 years, joined IB for the last 2 years of my high school and I have experienced some of my life-changing events here. The IB course at this school opened my mind towards the international section of studies and brought me to a level where I can compete with students globally. Since the program is slowly getting established at this point, I believe the students who want to pursue an outstanding career. After completing IB, I feel that the school helped me a lot at different stages and I can say that the experience I had was pretty memorable for me. Hence, I can say that most students will receive a valuable and memorable time where they get to learn about much more than just studies. </p>
    </div> */}
    {/* <div className='testimonilaBox'>
    <h5  className='parentsname' >Tisha Jindal</h5>
    
    <p className='parentstext'>Sanskar school has always been a world full of emotions for me. Going 14 years in past, I still remember how nervous I was to start this new journey of my life with Sanskar, and today, being graduated from here, I have tons of experiences which have defined my life. </p>
    <p className='parentstext'>One of the most memorable experience of this journey was the transition to IB from CBSE which seemed quite challenging. Regardless to say, life has been a roller coaster of emotions since then. All the teachers who helped me and supported me have tremendously contributed in my success, achieving a score of 42 out of 45 in IB - a score which I never even imagined I could get. The school gave me wings to pursue my dreams abroad, and with their immense support, I am lucky enough to having gained admission in many universities in the US and Canada. I will be attending Arizona State University as of now for Aerospace Engineering. However, my plans might change if I get an admission decision from Nanyang Technological University (Singapore) and I am really hopeful I would get in there. </p>
    <p className='parentstext'>Would like to thank all teachers and friends for being such a supporting pillar in my life decisions! And most of all, Thank you Sanskar for giving me so many unforgettable memories filled with laughter and some tears !! This would be a lifetime experience….</p>
    </div> */}
   
    <div className='testimonilaBox'>
   
    
    <p className='parentstext'>I would like to express my heartfelt appreciation for the outstanding quality of education provided at Sanskar school. The unwavering dedication and commitment of the entire staff of Cambridge board speaks volumes about them. As a parent, witnessing the positive changes and growth in my son as he is valued and supported gives me immense satisfaction. Thank you for creating an environment where students are nurtured with so much love and care.
</p>
<h5  className='parentsname' >Devaang Lamba</h5>
<h5  className='parentsname' >Parent </h5>
<h5  className='parentsname' >(CIE) </h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>Our family has moved to India after 15 years of staying abroad. After thorough consideration we have chosen Sanskar school as the place of studies for our children. We were glad to find a school that follows IB and Cambridge curriculum as these were the programmes that were followed at their previous school. We are grateful to the management staff for good organization of the enrollment process. We are grateful to the teachers of Sanskar school for being so supportive and welcoming during the adjustment period. They have been really helpful and caring.
      <p>Our kind thank you.</p>

      <h5  className='parentsname' >Pankaj Khalwani</h5>
      <h5  className='parentsname' >Parent </h5>
      <h5  className='parentsname' >(CIE)</h5>

</p>
    </div>
    {/* <div className='testimonilaBox'>
    <h5  className='parentsname'>Parent of Devaang Lamba, CP 8</h5>
    
    <p className='parentstext'>Our family has moved to India after 15 years of staying abroad. After thorough consideration we have chosen Sanskar school as the place of studies for our children. We were glad to find a school that follows IB and Cambridge curriculum as these were the programmes that were followed at their previous school. We are grateful to the management staff for good organization of the enrollment process. We are grateful to the teachers of Sanskar school for being so supportive and welcoming during the adjustment period. They have been really helpful and caring.

Our kind thank you!
</p>
    </div> */}
    <div className='testimonilaBox'>
   
    
    <p className='parentstext'>Sanskar School has proven to be an exceptional choice for my son’s education in the 8th standard Cambridge Board curriculum. The school stands out for its focus on academic excellence while fostering a holistic learning environment. Teachers are supportive and dedicated, ensuring personalised attention. 
</p>
<h5  className='parentsname'>Col JS Lamba, SM</h5>
<h5  className='parentsname'>Parent</h5>
<h5  className='parentsname'>(CIE)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>Despite the workload and pressure, IB is a curriculum worth taking. It 
gives the student insight of the pattern of international education which 
is good for a student’s development. The IB has made my daughter a critical 
thinker and has taught her many good things. 

<h5  className='parentsname'>Ms. Anita Jindal</h5>
<h5  className='parentsname'>Parent</h5>
<h5  className='parentsname'>(IBDP)</h5>
</p>
    </div>

    <div className='testimonilaBox'>
    
    <p className='parentstext'>IBDP has been a very big part of Ananya’s life. I have seen her 
manage and organise herself in a more effective way since then. The 
programme has pushed her to go out and talk to people and 
participate in new activities. I feel it’s a unique way of making 
students learn and I am happy with it.</p>

<h5  className='parentsname'>Mr. Sundeep Singh</h5>
<h5  className='parentsname'>Parent</h5>
<h5  className='parentsname'>(IBDP)</h5>
    </div>
    
    <div className='testimonilaBox'>

    
    <p className='parentstext'>I feel like Sanskar School instead of IB is helping my daughter grow as a person and is helping her 
improve in factors other than studies too. After joining IB she has started 
to become more curious about so many different topics. I feel that IB will 
not only help her grow as a student, but also as a person.</p>
<h5  className='parentsname'>Mr. Mukesh Chander</h5>
<h5  className='parentsname'>Parent </h5>
<h5  className='parentsname'>(IBDP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The IB Curriculum had a positive impact on my child. She has developed a positive attitude after taking IB. The IB programme of Sanskar is helping my daughter achieve her goals and is really satisfactory. </p>
<h5  className='parentsname'>Mr. Ankur Jindal</h5>
<h5  className='parentsname'>Parent</h5>
<h5  className='parentsname'>(IBDP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>Many many congratulations to you and entire school team Sanskar School  never fail to amaze us with its creativity, hardwork and sheer determination to rise up.</p>
    <h5  className='parentsname' >Pranshi</h5>
    <h5  className='parentsname' >Parent</h5>
    <h5  className='parentsname' >(IBPYP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>Today morning while dropping my grand daughter Mumal lohamaror class V B I had an informal chat. I would like you to compliment the teachers who are guiding her for being a true teacher where mumal said that Dadu my teacher is very nice and I love her conduct and behaviour which is very pleasing   I grew up to my age  My children grew up to be adults at this thought by my grand daughter made me happy and thought to share  with u ... </p>
    <h5  className='parentsname' >Devanand Lohamaror</h5>
    <h5  className='parentsname' >Parent </h5>
    <h5  className='parentsname' >(IBPYP)</h5>
    </div>
    {/* <div className='testimonilaBox'>
 
    
    <p className='parentstext'>I wanted to take a moment to express my heartfelt gratitude for encouraging Hitanshi to take on the main lead role. Your support and motivation have made a significant impact on her confidence and enthusiasm.

It's wonderful to see her so excited and committed to this opportunity. I truly appreciate the time and effort you’ve invested in helping her grow.

Thank you once again for being such an inspiring and supportive teacher.
</p>
    </div> */}
  
    <div className='testimonilaBox'>
    
    <p className='parentstext'>The school provides a prestigious educational environment enriched with diverse extracurricular opportunities, ensuring comprehensive skill development and growth for my child.</p>
    <h5  className='parentsname' >Shilpa Sameer</h5>
    <h5  className='parentsname' >Parent</h5>
    <h5  className='parentsname' >(IBDP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The school offers a prestigious educational experience with a wide range of extracurricular activities, helping me develop essential skills and grow in a supportive environment</p>
    <h5  className='parentsname' >Shubhashish Soral </h5>
    <h5  className='parentsname' >(Student)</h5>
    <h5  className='parentsname' >(IBDP )</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The IB Diploma Program has been a transformative experience, challenging me academically and personally. It has sharpened my critical thinking, broadened my global perspective, and prepared me for future academic success.</p>

    <h5  className='parentsname' >Rishi Mahala</h5>
    <h5  className='parentsname' >(Student)</h5>
    <h5  className='parentsname' >(IBDP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The IB Diploma Program has greatly enhanced our child's research abilities. It encourages in-depth inquiry, critical analysis, and independent thinking across diverse subjects. These skills will serve them well in both higher education and future endeavors.</p>
    <h5  className='parentsname' >Sunil Mahala</h5>
    <h5  className='parentsname' >Parent</h5>
    <h5  className='parentsname' >(IBDP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    
    <p className='parentstext'>The relationship between a teacher and his students is one of the most influential factors in a learning environment, A key element affecting students’ progress, Engagement of school and academic motivations!</p>

    <h5  className='parentsname' >Harsh Bareja</h5>
    <h5  className='parentsname' >Parent </h5>
    <h5  className='parentsname' > (IBPYP)</h5>

    </div>
    <div className='testimonilaBox'>
    
    <p className='parentstext'>Such a interactive and enthusiastic session! So happy that my child is in such wonderful hands… more power to teachers like you.</p>
    <h5  className='parentsname'>Rashmi Dugar</h5>
    <h5  className='parentsname'>Parent </h5>
    <h5  className='parentsname'> (IBPYP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    <p className='parentstext'>I want to thank you Ma’am. Aarush was very shy and was scared to speak his mind in front of others. But the way you communicate with him and make him speak his mind, he is improving. Now, I see a lot of change in his behaviour.</p>
    <h5  className='parentsname'>Sonu Jyanni</h5>
    <h5  className='parentsname'>Parent</h5>
    <h5  className='parentsname'>(IBPYP)</h5>
    </div>
    <div className='testimonilaBox'>
 
    <p className='parentstext'>We’re extremely thankful for efforts made by the teachers and the way they are dealing with the children in the present situation.</p>
    <p className='parentstext'>As a parent, we’re eager to extend any support and happy to co-operate as much as we can.</p>
    <h5  className='parentsname'>Mr. Ashok Sharma</h5>
    <h5  className='parentsname'>Parents </h5>
    <h5  className='parentsname'>(IBPYP)</h5>
    </div>
    <div className='testimonilaBox'>
    
    <p className='parentstext'>A special thanks to all the teachers at sanskarjaipur who are doing tremendous job of taking online classes, checking messages, responding to students queries 24/7. I myself specially attend maths classes by Poornima ma’am. She makes maths a lovable subject. Kashika has started enjoying maths classes.Thank you teaches.</p>

    <h5 className='parentsname'>Kiran Shekhawat</h5>
    <h5 className='parentsname'>Parent </h5>
    <h5 className='parentsname'>(IBPYP)</h5>
    </div>



  </Carousel>
    </div>
  )
}

export default testimonialsData
